<header class="fixed-top">

    <nav class="navbar  navbar-expand-lg navbar-light bg-light" >
      <div class="container-fluid">
      <a class="navbar-brand d-flex " href="#" >  
         <img src="assets/images/logo-login.png" class="img-fluid" alt=""> 
         <div class="logo-text">
         <p> {{'form.university-hospital' | translate}}</p>
         <p>{{'form.saudi-electronic' | translate}}</p>
         </div>
  
    </a>
      <button class="navbar-toggler top" type="button" data-toggle="collapse" data-target="#navbar-contact" aria-controls="navbar-contact" aria-expanded="false" aria-label="Toggle navigation">
        <span class="ik ik-chevron-down "></span>
      </button>
      <div class="collapse  mr-auto navbar-collapse justify-content-end" id="navbar-contact">
        
          <div class="d-flex justify-content-start align-items-center address">
            <img src="assets/images/map.png">
            <div class="address-data">
            <p class="">   {{'landing.address' | translate}}   </p>
            <p class=" state">{{'landing.state' | translate}}     </p>
  
            </div>
          </div>  
  
          <div class="d-flex justify-content-start align-items-center address">
            <img src="assets/images/contacts.png">
            <div class="address-data">
            <p class="">   <a href="tel:00966112613500"> 00966112613500</a>  </p>
            <p class=" state"> <a href="mailto:contact@seu.edu.sa"> contact@seu.edu.sa </a>  </p>
  
            </div>
          </div> 
  
          <div class="d-flex justify-content-start align-items-center address">
            <img src="assets/images/hours.png">
            <div class="address-data">
            <p class="">   {{'landing.workhours' | translate}}    </p>
            <p class=" state"> {{'landing.hours' | translate}}   </p>
  
            </div>
          </div>
  
      </div>
    </div>
    </nav>
  
  <nav class="navbar navbar-expand-lg navbar-light main-nav" >
    <div class="container-fluid">
   <!--  <a class="navbar-brand" href="#">  
       <img src="assets/images/logo-login.png" class="img-fluid" alt=""> 
  </a> -->
    <button class="navbar-toggler top2" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="ik ik-align-center"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-center" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <a class=" nav-link  js-scroll active"  data-value="intro" href="#"  [routerLink]="['/']">{{'menu.Home' | translate}}</a>
        <!-- <a class="nav-item nav-link js-scroll " data-value="booking-steps" href="#">الحجز</a> -->
        <!-- <a class="nav-item nav-link js-scroll" data-value="statistics" href="#">إحصائيات</a> -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{'menu.service' | translate}} 
            <i  class="ik ik-chevron-down"></i>
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item"  [routerLink]="['/doctors']"> 
              <img  alt="SEU" class="img-fluid " src="assets/images/doctors2.png" style=" width:20px">
              <span>{{'menu.doctors' | translate}} </span>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item"  [routerLink]="['/majors']">
              <img  alt="SEU" class="img-fluid " src="assets/images/major.png" style=" width:20px">
             <span> {{'menu.major' | translate}} </span> 
            </a>
          </div>
        </li>
        <a class="nav-item nav-link js-scroll" data-value="news" href="#">{{'menu.news' | translate}}</a>
        <a class="nav-item nav-link js-scroll" data-value="footer" href="#"> {{'menu.contact' | translate}} </a>
  
  
      </div>
      <div class="lang mr-auto  d-none d-sm-block">  
        <a class=""  [routerLink]="['/auth']"  style="margin: 0 10px;">
          <img src="assets/images/login-top.png" width="28px">
        </a>
   
        <a href="javascript:void(0)" *ngIf="translate.currentLang =='en'" class="social" style="margin: 0 10px;" (click)="langAR('AR')"> 
          <img src="assets/images/ar.png" width="25px">
        </a>
       <a href="javascript:void(0)" *ngIf="translate.currentLang =='AR'"   class="social"  style="margin: 0 10px;"  (click)="langEn('en')">
        <img src="assets/images/en.png" width="25px">
      </a>
        </div>  
    </div>
    <div class="lang mr-auto  d-lg-none mobile-icon">  
      <a class=""  [routerLink]="['/auth']" role="button" style="margin: 0 10px;">
        <img src="assets/images/login-top.png" width="28px">
      </a>
    
      <a href="javascript:void(0)" *ngIf="globals.CurrentLang =='en'" class="social" style="margin: 0 10px;" (click)="langAR('AR')"> 
        <img src="assets/images/ar.png" width="25px">
      </a>
     <a href="javascript:void(0)"*ngIf="globals.CurrentLang =='AR'"   class="social"  style="margin: 0 10px;"  (click)="langEn('en')">
      <img src="assets/images/en.png" width="25px">
    </a>
      </div>
      
  
  </div>
  </nav>
  
  </header>
  
  <section class="intro" id="intro">
    <div class="swiper-container page-slide">
  
   <div class="swiper-wrapper">
     
          <div class="swiper-slide" style="background-image: url(assets/images/slider-1.png); ">
            <div class="over">
                   <div class="container">
                       <div class="swiper-slide-inner ">
                         <div class="sec-header">
                         <h2 class="animate__animated animate__bounceInDown  animate__slow ">{{'form.university-hospital' | translate}} <span>{{'form.saudi-electronic' | translate}}  </span></h2>
                         </div>
                         <p class="animate__animated animate__bounceInUp animate__slow ">
                          {{'landing.desc' | translate}}
                          </p>
                        </div>
                   </div>
                   </div>
               </div>
               <div class="swiper-slide" style="background-image: url(assets/images/slide11.jpg); ">
                <div class="over">
                  <div class="container">
                      <div class="swiper-slide-inner ">
                        <div class="sec-header">
                        <h2> <span> {{'landing.statistics' | translate}}   </span></h2>
                        </div>
                    
                       
              
              
              
                      </div>
                  </div>
                  </div>
               </div>
  
           <!--     <div class="swiper-slide" style="background-image: url(assets/images/slide12.jpg); ">
                <div class="over">
                  <div class="container">
                      <div class="swiper-slide-inner ">
                        <div class="sec-header">
                        <h2> <span>{{'landing.booking' | translate}}  </span></h2>
                        </div>
                    
                        <div class="book">
                          <div class=" d-flex justify-content-around">
                            <div class=" "> 
                              <div class="d-flex justify-content-around align-items-center">
                                <div>
                              <img  src="assets/images/log.png"  alt="seu">     
                              <h3>{{'landing.login' | translate}}</h3>
                              </div>
                              <div class="step">
                              <i  class="ik ik-chevron-left"></i>
                            </div>
                               </div>
                            </div>
  
                            <div class=""> 
                              <div class="d-flex justify-content-around align-items-center">
                                <div>
                              <img  src="assets/images/healthcare.png"  alt="seu">     
                              <h3>{{'Booking.selectmajor' | translate}}   </h3>
                              </div>
                              <div class="step">
                              <i  class="ik ik-chevron-left"></i>
                            </div>
                               </div>
                            </div>
  
                            <div class=" "> 
                              <div class="d-flex justify-content-around align-items-center">
                                <div>
                              <img  src="assets/images/doct.png"  alt="seu">     
                              <h3> {{'Booking.selectdoctor' | translate}}   </h3>
                              </div>
                              <div class="step">
                              <i  class="ik ik-chevron-left"></i>
                            </div>
                               </div>
                            </div>
  
                            <div class=""> 
                              <div class="d-flex justify-content-around align-items-center">
                                <div>
                              <img  src="assets/images/hou.png"  alt="seu">     
                              <h3> {{'landing.appi' | translate}}   </h3>
                              </div>
                              <div class="step">
                              <i  class="ik "></i>
                            </div>
                               </div>
                            </div>
                        </div>  
                        </div> 
  
                       </div>
                  </div>
                  </div>
               </div> -->
               
   </div>
      <div class="swiper-pagination"></div>
   <!-- Add Arrows -->
    <div class="swiper-button-next"></div>
   <div class="swiper-button-prev"></div> 
  </div>
   </section>
    
  <!-- End Slider -->